const SELECTOR_INPUT = 'select,input';
const SELECTOR_LABEL = 'label';
const CLASS_IS_DISABLED = 'is-disabled';

const TEXT_OPTIONAL = '(Optionnel)';

export default class Field {
	constructor(el) {
		this.el = el;

		this.refs = {
			input: this.el.querySelector(SELECTOR_INPUT),
			label: this.el.querySelector(SELECTOR_LABEL),
		};

		this.props = {
			initialLabel: this.refs.label.textContent,
		};

		return this;
	}

	hide() {
		this.el.classList.add(CLASS_IS_DISABLED);
		this.refs.input.setAttribute('disabled', 'disabled');

		return this;
	}

	show() {
		this.el.classList.remove(CLASS_IS_DISABLED);
		this.refs.input.removeAttribute('disabled');

		return this;
	}

	setRequired(isRequired = true) {
		if (isRequired) {
			this.refs.input.setAttribute('required', 'required');
			this.refs.label.removeAttribute('data-optional');
		}
		else {
			this.refs.input.removeAttribute('required');
			this.refs.label.setAttribute('data-optional', TEXT_OPTIONAL);
		}

		return this;
	}

	changeLabel(newLabel = null) {
		this.refs.label.textContent = newLabel || this.props.initialLabel;

		return this;
	}

	setPriority(priority) {
		this.el.style.order = priority;
	}

	getValue() {
		return this.refs.input.value;
	}
}
